import { render, staticRenderFns } from "./dashboard-stores.vue?vue&type=template&id=f0aac27a&scoped=true&"
import script from "./dashboard-stores.vue?vue&type=script&lang=js&"
export * from "./dashboard-stores.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-stores.vue?vue&type=style&index=0&id=f0aac27a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0aac27a",
  null
  
)

export default component.exports